<template>
  <div>
    <!-- 功能组件，绑定微信或手机号 -->
  </div>
</template>

<script>
import qrcode from "qrcode";
import BTime from 'best-calendar';

export default {
  beforeDestroy() {
    this.bindWxTimer != null && clearInterval(this.bindWxTimer);
  },
  methods: {
    open(options = {}) {
      // open时传递oa进来
      const { bindType, oa } = options;
      this.options = options
      if (bindType === 'wx') {
        this.bindWxTimer != null && clearInterval(this.bindWxTimer)
        // 根据oa 传递的数据来判断
        this.getQrCode(oa)
            .then(this.createQrImg)
            .then(() => {
              this.bindWxTimer = setInterval(() => this.checkBindWx(oa), 2000)
              this.checkBindWx(oa)
            })
      }
      if (bindType === 'phone') {
        return this.bindPhone()
      }
      // switch (bindType) {
      //   case "wx":
      //     // 获取二维码 => 绘制二维码到canvas => 检测是否绑定
      //     this.bindWxTimer != null && clearInterval(this.bindWxTimer);
      //     return this.getQrCode()
      //       .then(this.createQrImg)
      //       .then(() => {
      //         this.bindWxTimer = setInterval(this.checkBindWx, 2000);
      //         this.checkBindWx();
      //       });
      //   case "phone":
      //     return this.bindPhone();
      //   default:
      //     break;
      // }
    },

    checkBindWx(type) {
      const { scene_id } = this;
      return this.$fetch
        .post({
          url: "/login?method=bind_wx",
          params: {
            scene_id,
            oa: type
          }
        })
        .then(
          (data) => {
            if (data.done) {
              this.bindWxTimer != null && clearInterval(this.bindWxTimer);
              this.openMessage(1, "绑定成功");
              this.$emit('bindwx-success', scene_id);
            }
          },
          e => {
            this.openMessage(0, e.error_text || "检测微信绑定错误");
            this.bindWxTimer != null && clearInterval(this.bindWxTimer);
          }
        );
    },

    bindPhone() {
      return this.$fetch
        .post({
          url: "/user",
          params: {
            phone: this.options.phone,
            code: this.options.code,
            realname: this.options.realname
          }
        })
        .then(
          data => {
            if (data.success) {
              this.openMessage(1, "绑定成功");
              return true;
            }
          }
        );
    },

    // 获取微信二维码
    getQrCode(type) {
      return this.$fetch
        .post({
          url: "/login?method=get_wx_ticket",
          params: {
            action: "bind",
            oa: type
          }
        })
        .then(
          (data) => {
            this.ticket_url = data.ticket_url;
            this.scene_id = data.scene_id;
          },
          e => this.openMessage(0, e.error_text || "获取微信二维码错误")
        );
    },

    createQrImg() {
      const el = this.options.el;
      const ticket_url = this.ticket_url;
      return new Promise(resolve => {
        qrcode.toCanvas(el, ticket_url, e => {
          if (e) {
            this.$emit('qrcode-expired');
            this.openMessage(0, "生成二维码失败");
          } else {
            this.$emit('qrcode-not-expired');
            resolve();
            const QrCountDown = new BTime.CountDown(1000 * 60 * 10, 0);
            QrCountDown.on('timend', () => {
              this.$emit('qrcode-expired');
            })
          }
        });
      });
    }
  }
};
</script>
